import { render, staticRenderFns } from "./MetricsDashboardSection.vue?vue&type=template&id=9e295300&scoped=true"
import script from "./MetricsDashboardSection.vue?vue&type=script&lang=js"
export * from "./MetricsDashboardSection.vue?vue&type=script&lang=js"
import style0 from "./MetricsDashboardSection.vue?vue&type=style&index=0&id=9e295300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e295300",
  null
  
)

export default component.exports